<template>
  <div class="app-wrapper">
    <header class="top-header">
      <div class="header-brand">
        <div class="brand-mark">T</div>
        <div class="brand-info">
          <span class="brand-name">thxily</span>
          <span class="brand-sub">感謝カード作成</span>
        </div>
      </div>

      <div class="header-actions">
        <button class="back-btn" type="button" v-on:click="back">一覧へ戻る</button>
      </div>
    </header>

    <main class="main-content">
      <div class="white-card">
        <div class="page-head">
          <div>
            <p class="page-kicker">THX card</p>
            <h1 class="page-title">THXカード作成</h1>
            <p class="page-copy">
              左でプレビューを確認しながら、右でカード名と既定設定を入力します。
              新規作成でも更新画面と同じ感覚で扱える構成です。
            </p>
          </div>
        </div>

        <form id="form" class="editor-grid" v-on:submit.prevent="create">
          <section class="preview-panel">
            <div class="preview-frame">
              <img :src="card.image" class="preview-img" alt="THX card preview" />
            </div>
            <div class="file-block">
              <label class="file-label" for="card-image">画像をアップロード</label>
              <input id="card-image" type="file" class="file-input" v-on:change="fileSelected" />
              <p class="file-hint">
                {{ selectedFileName || '選択中のファイルはありません' }}
              </p>
            </div>
          </section>

          <section class="form-panel">
            <div class="form-group">
              <label class="form-label" for="card-name">カード名</label>
              <input id="card-name" type="text" v-model="name" class="form-control" required />
            </div>

            <label class="checkbox-card" for="is_default">
              <input
                id="is_default"
                v-model="is_default"
                class="checkbox-input"
                type="checkbox"
              />
              <span>
                <strong>デフォルト</strong>
                <small>最初に使うカードとして一覧上で優先表示します。</small>
              </span>
            </label>

            <div class="action-row">
              <button type="submit" class="btn-primary">作成</button>
              <button type="button" v-on:click="back" class="btn-secondary">キャンセル</button>
            </div>
          </section>
        </form>
      </div>
    </main>
  </div>
</template>

<script>
import axios from "axios";
import router from "@/router";
import {useRoute} from 'vue-router';
import store from "@/store";

const DUMMY_IMG = "data:image/png;base64,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"

export default {
  data: function () {
    return {
      card: {
        image: DUMMY_IMG,
      },
      name: '',
      is_default: false,
      fileInfo: '',
      selectedFileName: '',
    }
  },
  async mounted() {
    const route = useRoute()
  },
  methods: {
    dummy: function () {
    },
    create: function () {
      let nodes = document.querySelectorAll(`#form :invalid`)
      if (nodes.length > 0) {
        return
      }
      const data = {
        id: null,
        name: this.name,
        is_default: this.is_default,
        image: this.card.image,
      };
      axios.post("/create_thx_card_image", data).then((res) => {
        router.push("/thx_cards")
      })
    },
    fileSelected: function (event) {
      if (!event.target.files || !event.target.files.length) {
        return;
      }
      this.fileInfo = event.target.files[0];
      this.selectedFileName = this.fileInfo ? this.fileInfo.name : '';
      store.dispatch("resizeImage", {'imageData': this.fileInfo, 'width': 1024, 'height': 512}).then((image) => {
        this.card.image = image;
      })
    },
    back: function () {
      router.push("/thx_cards")
    },
    logout: function () {
      store.dispatch("logout")
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700;800&display=swap');

.app-wrapper {
  min-height: 100vh;
  background:
    radial-gradient(circle at top right, rgba(59, 130, 246, 0.16), transparent 28%),
    linear-gradient(180deg, #dbe2ee 0%, #eef3f8 100%);
  font-family: 'Noto Sans JP', sans-serif;
}

.top-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 0 28px;
  min-height: 72px;
  background: rgba(15, 23, 42, 0.96);
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.18);
}

.header-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.brand-mark {
  width: 40px;
  height: 40px;
  border-radius: 14px;
  display: grid;
  place-items: center;
  background: linear-gradient(135deg, #38bdf8, #2563eb);
  color: #fff;
  font-weight: 800;
  box-shadow: 0 12px 24px rgba(37, 99, 235, 0.26);
}

.brand-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
  line-height: 1.2;
}

.brand-name {
  color: #f8fafc;
  font-size: 1rem;
  font-weight: 800;
}

.brand-sub {
  color: #94a3b8;
  font-size: 0.72rem;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.back-btn {
  min-height: 38px;
  padding: 0 16px;
  border-radius: 12px;
  border: 1px solid rgba(148, 163, 184, 0.4);
  background: transparent;
  color: #e2e8f0;
  font: inherit;
  font-size: 0.88rem;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.18s ease, background-color 0.18s ease, border-color 0.18s ease;
}

.back-btn:hover {
  background: rgba(148, 163, 184, 0.1);
  transform: translateY(-1px);
}

.main-content {
  max-width: 1180px;
  margin: 0 auto;
  padding: 34px 24px 76px;
}

.white-card {
  position: relative;
  padding: 28px;
  border-radius: 28px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.12);
  border: 1px solid rgba(148, 163, 184, 0.16);
}

.page-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 26px;
}

.page-kicker {
  margin: 0 0 8px;
  color: #2563eb;
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.page-title {
  margin: 0;
  color: #0f172a;
  font-size: clamp(1.6rem, 2.4vw, 2.2rem);
  line-height: 1.25;
}

.page-copy {
  max-width: 60ch;
  margin: 12px 0 0;
  color: #475569;
  line-height: 1.8;
}

.editor-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(320px, 0.8fr);
  gap: 24px;
  align-items: start;
}

.preview-panel,
.form-panel {
  display: grid;
  gap: 16px;
}

.preview-frame {
  border-radius: 22px;
  padding: 14px;
  background: linear-gradient(180deg, #f8fafc, #eef4ff);
  border: 1px solid #dbe4f0;
}

.preview-img {
  width: 100%;
  min-height: 300px;
  max-height: 420px;
  object-fit: contain;
  display: block;
  border-radius: 16px;
  background: #fff;
}

.file-block {
  display: grid;
  gap: 8px;
}

.file-label {
  color: #0f172a;
  font-size: 0.92rem;
  font-weight: 700;
}

.file-input {
  width: 100%;
  padding: 12px 14px;
  border-radius: 14px;
  border: 1px dashed #94a3b8;
  background: #f8fafc;
  font: inherit;
}

.file-hint {
  margin: 0;
  color: #64748b;
  font-size: 0.86rem;
  line-height: 1.6;
}

.form-group {
  display: grid;
  gap: 8px;
}

.form-label {
  color: #334155;
  font-size: 0.88rem;
  font-weight: 700;
}

.form-control {
  width: 100%;
  padding: 14px 15px;
  border-radius: 14px;
  border: 1px solid #cbd5e1;
  background: #f8fafc;
  color: #0f172a;
  font: inherit;
  transition: border-color 0.18s ease, box-shadow 0.18s ease, background-color 0.18s ease;
}

.form-control:focus {
  outline: none;
  border-color: #3b82f6;
  background: #fff;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.14);
}

.checkbox-card {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 16px;
  border-radius: 18px;
  background: #f8fafc;
  border: 1px solid #dbe4f0;
  cursor: pointer;
}

.checkbox-input {
  width: 18px;
  height: 18px;
  margin-top: 2px;
  accent-color: #2563eb;
}

.checkbox-card strong {
  display: block;
  color: #0f172a;
}

.checkbox-card small {
  display: block;
  margin-top: 4px;
  color: #64748b;
  line-height: 1.6;
}

.action-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 8px;
}

.btn-primary,
.btn-secondary {
  min-height: 46px;
  padding: 0 18px;
  border-radius: 14px;
  border: 1px solid transparent;
  font: inherit;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease, background-color 0.18s ease;
}

.btn-primary {
  background: #3B82F6;
  color: #fff;
  box-shadow: 0 10px 20px rgba(59, 130, 246, 0.18);
}

.btn-primary:hover {
  background: #2563EB;
  transform: translateY(-1px);
}

.btn-secondary {
  background: #fff;
  border-color: #cbd5e1;
  color: #334155;
}

.btn-secondary:hover {
  background: #f8fafc;
  transform: translateY(-1px);
}

@media (max-width: 960px) {
  .editor-grid {
    grid-template-columns: 1fr;
  }

  .page-head {
    flex-direction: column;
  }
}

@media (max-width: 640px) {
  .top-header {
    padding: 0 16px;
    align-items: flex-start;
    padding-top: 14px;
    padding-bottom: 14px;
  }

  .main-content {
    padding: 16px 12px 28px;
  }

  .white-card {
    padding: 18px;
    border-radius: 22px;
  }

  .action-row {
    flex-direction: column;
  }

  .back-btn,
  .btn-primary,
  .btn-secondary {
    width: 100%;
    justify-content: center;
  }
}
</style>
